// extracted by mini-css-extract-plugin
export default {"OneLine":"reportsList_OneLine__ZXg3G"};